// extracted by mini-css-extract-plugin
module.exports = {"root":"MyPlan_root__1ML0Z","subheading":"MyPlan_subheading__2yr5i","planName":"MyPlan_planName__3BHiF","price":"MyPlan_price__169ao"};